import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { jobService } from '../services/api';

function Careers() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadJobs();
  }, []);

  const loadJobs = async () => {
    try {
      const data = await jobService.index();
      setJobs(data.data || data || []);
    } catch (error) {
      console.error('Error loading jobs:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/" className="text-xl font-bold text-gray-900">Ortus</Link>
          <div className="flex gap-4">
            <Link to="/shop" className="text-blue-600">Shop</Link>
            <Link to="/login" className="text-blue-600">Login</Link>
          </div>
        </div>
      </nav>

      <main className="max-w-6xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold mb-8">Careers</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {jobs.map((job) => (
            <div key={job.id} className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold mb-1">{job.title}</h3>
              <p className="text-sm text-blue-600 mb-2">{job.department} &middot; {job.location} &middot; {job.type}</p>
              <p className="text-sm text-gray-600 mb-3 line-clamp-3">{job.description}</p>
              <div className="text-xs text-gray-400">Posted: {new Date(job.created_at).toLocaleDateString()}</div>
            </div>
          ))}
        </div>
        {jobs.length === 0 && <p className="text-gray-500 mt-4">No openings currently.</p>}
      </main>
    </div>
  );
}

export default Careers;
